import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Cookie, X } from 'lucide-react';
import { Link } from 'react-router-dom';

export const CookieBanner = () => {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const [isVisible, setIsVisible] = useState(false);

  const content = {
    en: {
      title: "We use cookies",
      message: "We use essential cookies to make our site work. These cookies are necessary for the shopping cart, language preferences, and secure checkout.",
      accept: "Accept",
      learnMore: "Learn more"
    },
    es: {
      title: "Usamos cookies",
      message: "Usamos cookies esenciales para que nuestro sitio funcione. Estas cookies son necesarias para el carrito de compra, preferencias de idioma y pago seguro.",
      accept: "Aceptar",
      learnMore: "Más información"
    },
    fr: {
      title: "Nous utilisons des cookies",
      message: "Nous utilisons des cookies essentiels pour faire fonctionner notre site. Ces cookies sont nécessaires pour le panier, les préférences de langue et le paiement sécurisé.",
      accept: "Accepter",
      learnMore: "En savoir plus"
    }
  };

  const c = content[lang] || content.en;

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      // Small delay to not show immediately on page load
      const timer = setTimeout(() => setIsVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-slide-up"
      data-testid="cookie-banner"
    >
      <div className="max-w-4xl mx-auto bg-[#1A1A1A] border border-[#333333] rounded-lg shadow-2xl">
        <div className="p-4 sm:p-6">
          <div className="flex items-start gap-4">
            <div className="hidden sm:flex shrink-0 w-10 h-10 bg-[#FF0099]/20 rounded-full items-center justify-center">
              <Cookie className="w-5 h-5 text-[#FF0099]" />
            </div>
            <div className="flex-1">
              <h3 className="font-heading text-white font-bold mb-2 flex items-center gap-2">
                <Cookie className="w-4 h-4 text-[#FF0099] sm:hidden" />
                {c.title}
              </h3>
              <p className="text-[#A3A3A3] text-sm mb-4">
                {c.message}
              </p>
              <div className="flex flex-wrap items-center gap-3">
                <button
                  onClick={handleAccept}
                  className="bg-[#FF0099] hover:bg-[#FF0099]/80 text-white font-bold px-6 py-2 text-sm transition-colors"
                  data-testid="cookie-accept-btn"
                >
                  {c.accept}
                </button>
                <Link
                  to="/privacy"
                  className="text-[#A3A3A3] hover:text-[#FF0099] text-sm transition-colors"
                  data-testid="cookie-learn-more"
                >
                  {c.learnMore}
                </Link>
              </div>
            </div>
            <button
              onClick={handleAccept}
              className="shrink-0 text-[#666666] hover:text-white transition-colors"
              aria-label="Close"
              data-testid="cookie-close-btn"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
